import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormComponentBase } from 'src/app/common/form-component-base';
import { Global } from 'src/app/common/global';
import { ISalaryType, ISalaryTypeTranslation } from 'src/app/services/api/api-model';
import { DataService } from 'src/app/services/api/data.service';
import { StaticDataService } from 'src/app/services/api/static-data.service';
import { SessionService } from 'src/app/services/session/session.service';
import { environment } from 'src/environments/environment';
var SalaryTypeTranslationDialogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SalaryTypeTranslationDialogComponent, _super);
    function SalaryTypeTranslationDialogComponent(dataService, sessionService, staticDataService) {
        var _this = _super.call(this) || this;
        _this.dataService = dataService;
        _this.sessionService = sessionService;
        _this.staticDataService = staticDataService;
        _this.visibleValue = false;
        _this.visibleChange = new EventEmitter();
        _this.translateComplete = new EventEmitter();
        _this.gridData = [];
        _this.inheritClass = 'grid-inherit-cell';
        _this.NameClass = '';
        _this.DescriptionClass = '';
        _this.DefaultPayslipTextClass = '';
        _this.ExplanationClass = '';
        _this.childIsDirty = Array(1).fill(false);
        return _this;
    }
    Object.defineProperty(SalaryTypeTranslationDialogComponent.prototype, "visible", {
        get: function () {
            return this.visibleValue;
        },
        set: function (value) {
            if (this.visibleValue !== value) {
                this.visibleValue = value;
                this.visibleChange.emit(value);
                if (value) {
                    this.prepareTranslationData(this.salaryType);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalaryTypeTranslationDialogComponent.prototype, "branding", {
        get: function () {
            return environment.branding;
        },
        enumerable: true,
        configurable: true
    });
    SalaryTypeTranslationDialogComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(SalaryTypeTranslationDialogComponent.prototype, "IsReadOnly", {
        get: function () {
            return this.sessionService.role.IsReadOnly;
        },
        enumerable: true,
        configurable: true
    });
    SalaryTypeTranslationDialogComponent.prototype.onDialogAction = function (action) {
        if (action === 'Update') {
            this.updateSalaryTypeTranslation();
        }
    };
    SalaryTypeTranslationDialogComponent.prototype.onSaveChange = function (value) {
        this.childIsDirty[0] = true;
    };
    SalaryTypeTranslationDialogComponent.prototype.prepareTranslationData = function (salaryType) {
        var _this = this;
        this.gridData = [];
        if (!salaryType) {
            return;
        }
        this.dataService.SalaryTypes_GetTranslations(salaryType.Id).subscribe(function (data) {
            _this.gridData = data;
        });
    };
    SalaryTypeTranslationDialogComponent.prototype.getFieldTranslation = function (fieldName) {
        var translationText;
        if (this.salaryType &&
            this.salaryType.SalaryTypeTranslations &&
            this.salaryType.SalaryTypeTranslations.length > 0) {
            var translation = this.salaryType.SalaryTypeTranslations.find(function (t) { return t.LanguageId === Global.SESSION.SignOnToken.LanguageId; });
            translationText = translation ? translation[fieldName] : undefined;
        }
        return translationText;
    };
    SalaryTypeTranslationDialogComponent.prototype.getBaseTranslation = function (fieldName, languageId) {
        if (!this.salaryType || !this.salaryType.BaseSalaryType) {
            return undefined;
        }
        var translationText;
        if (this.salaryType.BaseSalaryType.SalaryTypeTranslations &&
            this.salaryType.BaseSalaryType.SalaryTypeTranslations.length > 0) {
            var translation = this.salaryType.BaseSalaryType.SalaryTypeTranslations.find(function (t) { return t.LanguageId === languageId; });
            translationText = translation ? translation[fieldName] : undefined;
        }
        return translationText ? translationText : this.salaryType.BaseSalaryType[fieldName];
    };
    SalaryTypeTranslationDialogComponent.prototype.updateSalaryTypeTranslation = function () {
        var _this = this;
        if (!this.gridData) {
            return;
        }
        if (this.childIsDirty[0] && this.gridData) {
            this.dataService.SalaryTypes_SetTranslations(this.gridData).subscribe(function (data) {
                _this.translateComplete.emit();
                _this.gridData = data;
                _this.visible = false;
            });
        }
    };
    return SalaryTypeTranslationDialogComponent;
}(FormComponentBase));
export { SalaryTypeTranslationDialogComponent };
